export default __webpack_public_path__ + "static/media/1775.60601352.png";